<template>
    <v-form ref="form" @submit="submit" v-model="formValid" style="height: 100%">
        <div class="title-config">
            <div class="label mt-12" style="margin-bottom: 3px">{{ $f.tc('condition') }}</div>
        </div>
        <div v-show="itemList.length !== 0">
            <div>
                <div class="row-config" style="margin-bottom: 3px">
                    <div class="config-source" style="font-weight: 700; font-size: 14px;">Source</div>
                    <div class="config-field" style="font-weight: 700; font-size: 14px;">Field</div>
                    <div class="config-operator" style="font-weight: 700; font-size: 14px;">{{
                            $f.tc('operator')
                        }}
                    </div>
                    <div class="config-value" style="font-weight: 700; font-size: 14px;">{{ $f.tc('value') }}</div>
                    <div class="config-action"></div>
                </div>
                <div
                    v-for="(item, index) in itemList"
                    :key="index"
                    class="row-config"
                    style="margin-bottom: 6px"
                >
                    <div class="config-source">
                        <v-select
                            outlined
                            v-model="item.source"
                            :items="sourceList"
                            item-text="text"
                            item-value="value"
                            class="input-custom"
                            @change="updateAllField(item)"
                        ></v-select>
                    </div>
                    <div class="config-field">
                        <v-combobox
                            outlined
                            v-model="item.field"
                            :items="getDataInputSuggestion(item)"
                            @change="updateField(item)"
                            class="input-custom">
                        </v-combobox>
                    </div>
                    <div class="config-operator">
                        <v-select
                            outlined
                            v-model="item.operator"
                            :items="updateOperatorList(item)"
                            item-text="text"
                            item-value="value"
                            class="input-custom">
                        </v-select>
                    </div>
                    <div class="config-value">
                        <ScenarioComboBox
                            v-if="['is_one_of', 'is_not_one_of'].includes(item.operator)"
                            v-model="item.value"
                            :multiple="true"
                            class="custom-combobox"
                        ></ScenarioComboBox>
                        <v-text-field
                            v-if="['is', 'is_not'].includes(item.operator)"
                            outlined
                            v-model="item.value"
                            class="input-custom"
                            :readonly="readOnlyValue">
                        </v-text-field>
                        <v-text-field
                            v-if="['>'].includes(item.operator)"
                            type="number"
                            v-model="item.value"
                            class="input-custom"
                            min="0"
                            @focusout="validateFieldFromTo(item)"
                        />
                        <div v-if="['is_between', 'is_not_between'].includes(item.operator)" style="display: flex">
                            <v-text-field
                                type="number"
                                :placeholder="$f.tc('from')"
                                v-model="item.from"
                                class="input-custom"
                                min="0"
                                @focusout="validateFieldFromTo(item)"
                            />
                            <img src="/img/arrow-right-2.svg" alt="icon-from-to" class="px-1">
                            <v-text-field
                                type="number"
                                :placeholder="$f.tc('to')"
                                v-model="item.to"
                                class="input-custom"
                                @focusout="validateFieldFromTo(item)"
                            />
                        </div>
                    </div>
                    <div class="config-action">
                        <div class="btn-icon" @click="removeItem(index)">
                            <img
                                src="/img/delete-new.svg"
                                alt="icon-delete-condition"
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="display: flex; align-items: center">
            <div class="btn-outline-secondary" @click="addItem()">
                {{ $t('addNew') }}
            </div>
        </div>
    </v-form>
</template>

<script>


import {mapState} from "vuex";
import BaseConfig from "@/views/Campaign/Form/Step4/BaseConfig";
import ScenarioComboBox from "@/views/Scenario/components/ScenarioComboBox";

export default {
    name: "QCBatchConditionEditor",
    components: {ScenarioComboBox},
    extends: BaseConfig,
    props: {
        resetConditionConfig: {
            type: Boolean,
            default: false
        },
        conditions: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            emptyItem: {
                source: 'customer_properties',
                field: '',
                operator: 'is',
                value: '',
                from: 0,
                to: 0
            },
            sourceList: [
                {text: 'Customer properties', value: 'customer_properties'},
                {text: 'Data collection', value: 'data_collection'},
                {text: 'System', value: 'system'},
                {text: 'NLP', value: 'nlp'}
            ],
            operatorList: [
                {text: 'is', value: 'is'},
                {text: 'is not', value: 'is_not'},
                {text: 'is one of', value: 'is_one_of'},
                {text: 'is not one of', value: 'is_not_one_of'},
                {text: 'is between', value: 'is_between'},
                {text: 'is not between', value: 'is_not_between'},
            ],
            readOnlyValue: false,
        }
    },
    computed: {
        ...mapState({
            qcCampaign: state => state.qccampaign.campaign,
            dataInputSuggestion: state => state.qccampaign.dataInputSuggestion,
        })
    },
    methods: {
        getDataInputSuggestion(item) {
            if (!this.dataInputSuggestion || !item.source) {
                return []
            }
            return this.dataInputSuggestion[item.source]
        },
        updateAllField(item) {
            item.field = ''
            item.operator = item.source === 'nlp' ? 'is_between' : 'is'
            item.from = ''
            item.to = ''
            item.value = ''

        },
        updateField(item) {
            if (item.source === 'nlp' && item.field === '$fallback') {
                item.operator = 'is'
                item.value = '1'
            }
            if (item.source === 'nlp' && item.field === 'confidence') {
                item.from = '0'
                item.to = '70'
            }
            if (item.source === 'nlp' && item.field === '$countReprompt') {
                item.value = 0
            }
        },
        updateOperatorList(item) {
            this.readOnlyValue = false
            if (item.source === 'nlp') {
                if (item.field === 'confidence') {
                    item.operator = 'is_between'
                    return [{text: 'is between', value: 'is_between'}]
                } else if (item.field === '$fallback') {
                    this.readOnlyValue = true
                    item.operator = 'is'
                    return [{text: 'is', value: 'is'}]
                } else if (item.field === '$countReprompt') {
                    item.operator = '>'
                    return [{text: '>', value: '>'}]
                } else return this.operatorList
            }
            return this.operatorList
        },
        validateFieldFromTo(item) {
            if (!item.source === 'nlp') return

            if (+item.from < 0 || +item.from > 100) {
                this.$appService.toastError(this.$f.tc('validateFromToConfidence', [item.field]))
                item.from = '0'
            }

            if (+item.to < 0 || +item.to > 100) {
                this.$appService.toastError(this.$f.tc('validateFromToConfidence', [item.field]))
                item.to = '100'
            }
            if (item.operator === '>' && +item.value < 0) {
                this.$appService.toastError(this.$f.tc('validateValueCountReprompt', [item.field]))
                item.value = '0'
            }
        }
    },
    watch: {
        itemList: {
            deep: true,
            handler: function (itemList) {
                this.$emit('updateItem', itemList)
            }
        },
        resetConditionConfig: {
            deep: true,
            handler: function () {
                this.itemList = []
            }
        },
        conditions: {
            deep: true,
            handler: function (newConditions) {
                if (newConditions.length > 0) {
                    this.itemList = newConditions
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.title-config {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
        font-size: 14px;
        font-weight: 700;
    }
}


.input-custom {
    position: relative;

    ::v-deep {
        .v-input__slot {
            height: 36px;
            background: #FFFFFF;
            border-radius: 0;
            border: 1px solid #DADFEC;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

.custom-combobox {
    height: 36px;
    background: #FFFFFF;
    border-radius: 0;
    border: 1px solid #DADFEC;
    outline: none;
    font-size: 14px;
    padding: 6px 12px;
    margin: 0;
    display: flex;
    align-items: center;

    &:before, &:after {
        border: none !important;
    }

    ::v-deep * {
        .v-select__selections {
            white-space: nowrap;
            padding-top: 4px;
            min-height: 0;
        }

        .v-input__append-inner {
            display: none;
        }
    }
}

.row-config {
    display: flex;
    align-items: center;

    .config-source, .config-field, .config-value {
        width: 225px;
        margin-right: 6px;
        color: #8A97AA;
    }

    .config-operator {
        width: 150px;
        margin-right: 6px;
        color: #8A97AA;
    }

    .config-action {
        width: 20px;
    }
}

::v-deep {
    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 10px;
    }

    .v-input__slot {
        margin-bottom: 0 !important;
    }

    .v-select {
        .v-text-field__details {
            right: 30px;
            top: 9px;
        }

        .v-input__slot {
            padding: 6px 3px 6px 12px;
        }
    }
}
</style>
